/* esm.sh - prop-types@15.8.1 */
export * from "/*prop-types@15.8.1/esnext/prop-types.mjs";
export { default } from "/*prop-types@15.8.1/esnext/prop-types.mjs";
